module.exports = __webpack_public_path__ + "img/logo.e9ed7e74.png";